import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal, Spin, Image } from "antd";
import Modal from "react-modal";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const FarmerDetailsList = (props) => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [isPreviewVisible, setPreviewVisible] = useState(false);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, farmerId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this farmer detail?",
      onOk() {
        const data = {
          farmerId: farmerId,
        };

        setDeleteLoading(data);
        deleteOperation(
          {
            url: `/api/farmerEnrolment/`,
            method: "DELETE",
            body: data,
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
              setDeleteLoading(false);
            }

            if (data.error) {
              toast.error(data.error);
              setDeleteLoading(false);
            }
            FillDetail();
          },
          (error) => {
            const errorMessage =
              error?.response?.data?.error ||
              error?.message ||
              "Something went wrong.";
            toast.error(errorMessage);
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const { sendRequest: getFarmerData } = useHttp();

  const FillDetail = () => {
    getFarmerData(
      {
        url: `/api/farmerEnrolment/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          const sortedData = res.sort((a, b) => b.farmerId - a.farmerId);
          setData(sortedData);
          setAllData(sortedData);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getFarmerData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.farmerNo?.toLowerCase().includes(filetrtext) ||
        item.farmerName?.toLowerCase().includes(filetrtext) ||
        item.fieldExecutiveName?.toLowerCase().includes(filetrtext) ||
        item.farmerStatus?.toLowerCase().includes(filetrtext) ||
        item.category?.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      height: "550px",
      minHeight: "550px",
      overflow: "auto",
      //  border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (id) => {
    setSelectedData(null);
    if (id) {
      getFarmerData(
        {
          url: `/api/farmerEnrolment/?orgId=${localStorage.getItem(
            "orgId"
          )}&empId=${localStorage.getItem("empId")}&farmerId=${id}`,
        },
        (res) => {
          if (res) {
            setSelectedData(res);
          }
        }
      );
    }
    setIsModalOpen(true);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (input) => {
    console.log(input);
    setSelectedApprovalData(input);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.farmerId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/farmerEnrolmentApproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const pdfContainerRef = useRef(null);
  // const generatePDF = (farmerNo) => {
  //   const input = pdfContainerRef.current;
  //   const pdfName = farmerNo || "farmer details";

  //   html2pdf(input, {
  //     margin: 10,
  //     filename: `${pdfName}.pdf`,
  //     image: { type: "png", quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
  //     pagebreak: { mode: "avoid-all" },
  //   });
  // };

  const generatePDF = async (farmerNo) => {
    const input = pdfContainerRef.current;
    const pdfName = farmerNo || "farmer_details";

    if (input) {
      try {
        const canvas = await html2canvas(input, {
          scale: 2, // High resolution
          useCORS: true, // Enable cross-origin handling
        });

        const imgData = canvas.toDataURL("image/png"); // Convert canvas to image
        const pdf = new jsPDF("portrait", "pt", "a4");

        const imgWidth = 595.28; // A4 width in points
        const pageHeight = 841.89; // A4 height in points
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // Add the first page
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Handle multi-page PDFs
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save(`${pdfName}.pdf`);
      } catch (error) {
        console.error("Error generating PDF:", error);
        alert(
          "Failed to generate PDF. Please check the images or console for errors."
        );
      }
    }
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div>
          <h4 className="card-title">
            <b>Farmer Enrolment Detail</b>
          </h4>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr style={{ border: "1px solid black" }} />
          </div>
          {selectedData && (
            <div className="content" ref={pdfContainerRef}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-body box-profile">
                        <div
                          className="text-center"
                          style={{ marginBottom: "10px" }}
                        >
                          <img
                            className="profile-user-img img-fluid img-circle"
                            src={`${process.env.REACT_APP_FILE_URL}${selectedData.urlProfile}`}
                            alt="User profile"
                            style={{
                              width: "100px",
                              height: "100px",
                              marginBottom: "5px",
                            }}
                          />
                        </div>

                        <h3
                          className="profile-username text-center"
                          style={{ margin: "5px 0" }}
                        >
                          {selectedData.farmerName}
                        </h3>

                        <div className="row">
                          <div className="col-md-6">
                            <ul className="list-group list-group-unbordered mb-3">
                              <li className="list-group-item">
                                Field Executive:
                                <span className="float-right">
                                  {selectedData.fieldExecutiveName}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Farmer No:
                                <span className="float-right">
                                  {selectedData.farmerNo}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Identification No:
                                <span className="float-right">
                                  {selectedData.identificationNo}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Registration Date:
                                <span className="float-right">
                                  {selectedData.registrationDate}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Date of Birth:
                                <span className="float-right">
                                  {selectedData.dob}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Age Range:
                                <span className="float-right">
                                  {selectedData.ageRange}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Gender:
                                <span className="float-right">
                                  {selectedData.gender}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Mobile:
                                <span className="float-right">
                                  {selectedData.mobile}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Email:
                                <span className="float-right">
                                  {selectedData.email}
                                </span>
                              </li>
                            </ul>
                          </div>

                          <div className="col-md-6">
                            <ul className="list-group list-group-unbordered mb-3">
                              <li className="list-group-item">
                                Address:
                                <span className="float-right">
                                  {selectedData.address}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Pincode/Zip Code:
                                <span className="float-right">
                                  {selectedData.pinCode}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Country:
                                <span className="float-right">
                                  {selectedData.country}
                                </span>
                              </li>
                              <li className="list-group-item">
                                State:
                                <span className="float-right">
                                  {selectedData.state}
                                </span>
                              </li>
                              <li className="list-group-item">
                                City:
                                <span className="float-right">
                                  {selectedData.city}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Village:
                                <span className="float-right">
                                  {selectedData.villageName}
                                </span>
                              </li>
                              <li className="list-group-item">
                                LGA:
                                <span className="float-right">
                                  {selectedData.lga}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Farmer Education:
                                <span className="float-right">
                                  {selectedData.farmerEducation}
                                </span>
                              </li>
                              <li className="list-group-item">
                                Id Proof:
                                <span className="float-right">
                                  {selectedData.idProof}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="row border p-3 rounded">
                          <div className="col-md-6">
                            <p>
                              <strong>ID Proof Attachment</strong>
                            </p>
                            <img
                              src={`${process.env.REACT_APP_FILE_URL}${selectedData?.urlAttachment}`}
                              alt={`Plot photo`}
                              width={200}
                              height={150}
                            />
                          </div>{" "}
                          <div className="col-md-6">
                            <p>
                              <strong>Signature</strong>
                            </p>
                            <img
                              src={`${process.env.REACT_APP_FILE_URL}${selectedData?.signatureAttachment}`}
                              alt={`Plot photo`}
                              width={200}
                              height={150}
                            />
                          </div>
                        </div>
                        <br />
                        <div className="row border p-3 rounded">
                          <div className="col-md-12">
                            <p>
                              <strong>Screen Shot Attachment</strong>
                            </p>

                            <div
                              class="filtr-item col-sm-2"
                              data-category="1"
                              data-sort="white sample"
                            >
                              <Image
                                width={200}
                                height={300}
                                preview={{
                                  visible: isPreviewVisible,
                                  onVisibleChange: (visible, prevVisible) =>
                                    setPreviewVisible(visible),
                                }}
                                // src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                                src={`${process.env.REACT_APP_FILE_URL}${selectedData?.urlScreenshot}`}
                              />
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {selectedData && (
            <div className="row no-print mt-2">
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-primary float-right generate-pdf-button"
                  style={{ marginRight: 5 }}
                  onClick={() =>
                    generatePDF(selectedData && selectedData.farmerNo)
                  }
                >
                  <i className="fas fa-download" /> Generate PDF
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-9">
            <label className="card-title  my-3">
              {" "}
              &nbsp; &nbsp;Farmer Enrolment Details{" "}
            </label>{" "}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center table-responsive">
                        <thead>
                          <tr>
                            <th>Farmer Name</th>
                            <th>Farmer No</th>
                            <th>Plot Size(ha)</th>
                            <th>Farmer Category</th>
                            <th>Field Executive</th>
                            <th>LGA</th>
                            <th>State</th>
                            <th>Farmer Status</th>
                            <th>Edit</th>
                            <th>Approval</th>
                            <th>View</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.farmerName}</td>
                                <td>{x.farmerNo}</td>
                                <td>{x.plotSizeInHa}</td>
                                <td>{x.category}</td>
                                <td>{x.fieldExecutiveName}</td>
                                <td>{x.lga}</td>
                                <td>{x.state}</td>
                                <td>{x.farmerStatus}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {x.approved === 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved === 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x.farmerId)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  {deleteLoading === x ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        handleDelete(e, x.farmerId)
                                      }
                                      className="btn"
                                      disabled={
                                        x.approved === 1 || x.approved === 2
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Enrolment Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default FarmerDetailsList;
